import { useState, useEffect } from 'react';
import FileInfo from '../../../Components/fileupload/FileInfo';
import { Row, Col, Container } from 'react-bootstrap';
import GenericMessage from '../../../Components/GenericMessage/GenericMessage';
import CustomClientError from '../../errorhandling/CustomClientError';

const UploadDocumentsOverlay = ({
  files,
  setFiles,
  filesLoader,
  setFieldValue,
  formUploadStatus,
  fileUploadStatus,
  serverError,
}) => {
  const [displayMessage, setDispalyMessage] = useState(true);
  const handleClose = () => setDispalyMessage(false);

  useEffect(() => {
    setDispalyMessage(true);
  }, [fileUploadStatus]);

  return (
    <div className="container-wrapper">
      <Container>
        {formUploadStatus &&
          fileUploadStatus !== 'uploaded' &&
          fileUploadStatus !== 'failed' && (
            <Row className="">
              <Col sm={12}>
                <GenericMessage
                  messageType="warning"
                  title={'Note'}
                  message={`Please wait and do not close this page untill we upload ${
                    files.length > 1 ? 'all your files' : 'your file'
                  }`}
                  showMessage={displayMessage}
                  wrapperClasses={'px-2 my-4'}
                  handleOnClose={handleClose}
                />
              </Col>
            </Row>
          )}
        {formUploadStatus && fileUploadStatus === 'uploaded' && (
          <Row className="">
            <Col sm={12}>
              <GenericMessage
                messageType="success"
                title={'Done'}
                message={`${files.length > 1 ? 'All F' : 'F'}ile${
                  files.length > 1 ? 's' : ''
                } has been uploaded successfully. `}
                showMessage={displayMessage}
                wrapperClasses={'px-2 my-4'}
                handleOnClose={handleClose}
              />
            </Col>
          </Row>
        )}
        {formUploadStatus && fileUploadStatus === 'failed' && (
          <Row className="">
            <Col sm={12}>
              <GenericMessage
                messageType="warning"
                title={'Note'}
                message={
                  'Some files have not been uploaded. Please try uploading them again. If you need to close the window, you can re-upload the remaining documents at a later time.'
                }
                showMessage={displayMessage}
                wrapperClasses={'px-2 my-4'}
                handleOnClose={handleClose}
              />
            </Col>
          </Row>
        )}

        {serverError ? (
          <Row className="px-2 mt-3">
            <Col sm={12}>
              <CustomClientError
                ErrorHeading="Something went wrong with request!"
                ErrorMessage="Server request failed. Please contact support team."
                CustomClasses="server-error-wrapper p-0"
              />
            </Col>
          </Row>
        ) : (
          <Row className="px-2 mt-3">
            {files &&
              files.map((item, index) => (
                <Col key={index} sm={12}>
                  <FileInfo
                    files={files}
                    fileDetails={item}
                    setFiles={setFiles}
                    filesLoader={filesLoader}
                    setFieldValue={setFieldValue}
                    fileUploadStatus={item?.uploadStatus}
                    fileProgress={item?.uploadPercent}
                    showRemove={false}
                    readFileSize={false}
                  />
                </Col>
              ))}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default UploadDocumentsOverlay;
